// extracted by mini-css-extract-plugin
export var adCard = "_pf-8";
export var adCardBorder = "_pf-5";
export var arbiterButtonIcon = "_pf-p";
export var buttonIcon = "_pf-o";
export var container = "_pf-e";
export var copyButton = "_pf-m";
export var darkGrey = "_pf-u";
export var deliveryDate = "_pf-2";
export var divider = "_pf-n";
export var editModeWrapper = "_pf-7";
export var empty = "_pf-a";
export var errorIcon = "_pf-d";
export var filledCircle = "_pf-4";
export var fulfillmentFooter = "_pf-j";
export var grey = "_pf-s";
export var header = "_pf-i";
export var headerWrapper = "_pf-h";
export var highlighted = "_pf-6";
export var historyEntry = "_pf-3";
export var mobileColumn = "_pf-v";
export var mobileColumnReverse = "_pf-w";
export var orderDetailsContainer = "_pf-g";
export var orderMetadata = "_pf-l";
export var orderMetadataWrapper = "_pf-k";
export var packagesContainer = "_pf-b";
export var product = "_pf-y";
export var productImage = "_pf-z";
export var productInfo = "_pf-x";
export var productTitle = "_pf-10";
export var strikethrough = "_pf-t";
export var tinyText = "_pf-r";
export var title = "_pf-9";
export var trackerCard = "_pf-1";
export var trackerCardWrapper = "_pf-0";
export var trackingContainer = "_pf-f";
export var trackingTitle = "_pf-c";
export var xTinyText = "_pf-q";